import { render, staticRenderFns } from "./CaseTravel.vue?vue&type=template&id=82048b4c"
import script from "./CaseTravel.vue?vue&type=script&lang=js"
export * from "./CaseTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports